export const SECTIONS = {
    filters: 'filters',
    summary: 'summary',
    download: 'download',
    app: 'app',
    unknown: 'unknown'
} as const;

export type Section = typeof SECTIONS[keyof typeof SECTIONS];

const SECTION_BY_KEY: Record<string, Section> = {
    GetClassrooms: SECTIONS.filters,
    GetDateTimeFilters: SECTIONS.filters,
    GetPastYearFilters: SECTIONS.filters,
    CertificateSummary: SECTIONS.summary,
    PastCertificates: SECTIONS.summary,
    SubmitRequest: SECTIONS.download,
    SubmitPastRequest: SECTIONS.download,
    GetDownload: SECTIONS.download,
    GetPastDownload: SECTIONS.download
};

export function resolveSection(queryKey?: readonly unknown[]): Section {
    if (!queryKey) return SECTIONS.unknown;

    for (const part of queryKey) {
        if (typeof part === 'string' && SECTION_BY_KEY[part]) {
            return SECTION_BY_KEY[part];
        }
    }

    return SECTIONS.unknown;
}
